const DoUtility = {
    get isMobile() {
        return globalThis.innerWidth <= 991;
    },
    SelfInstantiateOnLoad(factory) {
        if (!factory) {
            return;
        }
        const run = () => factory();
        if (document.readyState === "loading") {
            globalThis.addEventListener("DOMContentLoaded", run);
            return;
        }
        run();
    },
};
export default DoUtility;
